import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface PostSuccessModal {
  show: boolean;
  message: string;
  description: string;
}

const initialState: PostSuccessModal = {
  show: false,
  message: '',
  description: '',
};

export const successModalSlice = createSlice({
  name: 'successModal',
  initialState,
  reducers: {
    toggleModal: (state, action: PayloadAction<PostSuccessModal>) => {
      state.show = action.payload.show;
      state.message = action.payload.message;
      state.description = action.payload.description;
    },
  },
});

export const {toggleModal} = successModalSlice.actions;

export default successModalSlice.reducer;
